'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fLink$002ejs from "@ui5/webcomponents/dist/Link.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Link$() {
  this.D6 = null;
  $n_Lbe_doeraene_webcomponents_ui5_Link$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fLink$002ejs.default;
  this.D6 = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-link", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_Link$ as $c_Lbe_doeraene_webcomponents_ui5_Link$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Link$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Link$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Link$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Link$ as $h_Lbe_doeraene_webcomponents_ui5_Link$ };
$h_Lbe_doeraene_webcomponents_ui5_Link$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.D6;
});
var $d_Lbe_doeraene_webcomponents_ui5_Link$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Link$, "be.doeraene.webcomponents.ui5.Link$", ({
  gj: 1,
  ar: 1,
  b8: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Link$ as $d_Lbe_doeraene_webcomponents_ui5_Link$ };
var $n_Lbe_doeraene_webcomponents_ui5_Link$;
function $m_Lbe_doeraene_webcomponents_ui5_Link$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Link$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Link$ = new $c_Lbe_doeraene_webcomponents_ui5_Link$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Link$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Link$ as $m_Lbe_doeraene_webcomponents_ui5_Link$ };
